import { useState } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export const AuthForm = ({ error, onSubmit }) => {
  const [input, setInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    onSubmit(input.trim());
    setInput("");
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      className="w-full max-w-md border border-stroke bg-matte p-8 md:p-10"
      data-testid="admin-auth-form"
    >
      <div className="flex items-center gap-3 mb-6">
        <Lock size={18} strokeWidth={1.5} className="text-laser" />
        <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-laser">
          /// Admin access
        </p>
      </div>
      <h1 className="font-serif font-light text-3xl md:text-4xl text-ink leading-tight mb-2">
        Paste your admin token.
      </h1>
      <p className="font-sans text-sm text-steel mb-6">
        Sent via `X-Admin-Token` header. Kept for this session only.
      </p>
      <input
        type="password"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Admin token"
        autoFocus
        data-testid="admin-token-input"
        className="w-full bg-obsidian border border-stroke text-ink px-4 py-3 font-mono text-sm focus:outline-none focus:border-laser transition-colors"
      />
      {error && (
        <p className="mt-3 font-mono text-[11px] tracking-[0.2em] uppercase text-red-400" data-testid="admin-auth-error">
          {error}
        </p>
      )}
      <button
        type="submit"
        data-testid="admin-token-submit"
        className="btn-sweep btn-sweep-primary w-full mt-6 border border-laser text-ink px-6 py-4 font-mono text-xs tracking-[0.24em] uppercase"
      >
        Enter
      </button>
    </motion.form>
  );
};
